<img
  src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/login_home.svg"
  alt="login_images"
  class="aspect-square max-h-96 w-full object-contain"
  loading="eager" />

<p class="text-lavander-light text-center text-2xl leading-8 font-extrabold italic shadow-md">
  ¡BIENVENIDO A LA PISTA!
</p>

<p class="text-blue-cyan-light text-center text-base leading-6 font-bold italic">
  Inicia sesión para comenzar con tu carrera
</p>

<form
  autocomplete="off"
  [formGroup]="form"
  class="mx-auto w-full max-w-lg px-4"
  (ngSubmit)="submit()">
  <div class="relative mb-4">
    <icon
      name="person-icon"
      class="text-blue-teal absolute top-1/2 left-3 h-5 w-5 -translate-y-1/2" />
    <input
      type="text"
      formControlName="codigo_sap"
      placeholder="Código Sap"
      class="border-blue-teal text-blue-teal placeholder-blue-teal h-12 w-full rounded-lg border px-3 pl-10 text-base leading-6 font-bold italic" />
  </div>

  <div class="text-blue-teal relative mb-6">
    <icon
      name="lock-icon"
      class="text-blue-teal absolute top-1/2 left-3 h-5 w-5 -translate-y-1/2" />
    <input
      formControlName="password"
      placeholder="Contraseña"
      appTogglePassword
      style="color: aquamarine"
      class="border-blue-teal text-blue-teal placeholder-blue-teal h-12 w-full [appearance:textfield] rounded-lg border px-3 pr-10 pl-10 text-base leading-6 font-bold italic" />
  </div>

  <button
    class="button1 h-10 w-full"
    [disabled]="form.invalid || loading()"
    type="submit">
    Iniciar Sesión
  </button>

  <a
    routerLink="/password/new"
    class="text-blue-cyan-light mt-8 block text-center text-base leading-6 font-semibold">
    ¿Olvidaste tu contraseña?
  </a>
</form>
@if (loading()) {
  <loader [visible]="loading()"></loader>
}
@if (showError()) {
  <alert
    [visible]="showError()"
    [headetText]="'Iniciar sesión'"
    [title]="'Error la iniciar sesión'"
    [description]="error()"
    [image]="'https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/hint.webp'"
    [buttonText]="'Aceptar'"
    [secondaryButton]="false"
    (primaryClicked)="onAlertClose()" />
}
